import styled from "styled-components";
import colors from "../../constants/colors";

export const Container = styled("div")({
  width: "100%",
  marginBottom: "2rem",
});

export const ProgressContainer = styled("div")({
  width: "100%",
  height: "10px",
  display: "flex",
  position: "relative",
  backgroundColor: colors.GREY_5,
  borderRadius: "5px",
  overflow: "hidden",
  direction: "ltr",
});

export const ProgressFill = styled("div")<{ $progress: number }>(
  ({ $progress }) => ({
    width: `${$progress}%`,
    height: "100%",
    backgroundColor: colors.PURPLE,
    transition: "width 0.4s ease-in-out",
    borderRadius: "0 5px 5px 0",
    marginLeft: "auto",
  }),
);

export const Divider = styled("div")<{ $position: number }>((props) => ({
  position: "absolute",
  top: 0,
  bottom: 0,
  right: `${props.$position}%`,
  width: "2px",
  backgroundColor: colors.GREY_6,
}));

export const LabelContainer = styled("div")({
  width: "100%",
  display: "flex",
  justifyContent: "space-around",
  marginBottom: "0.5rem",
});

export const Label = styled("div")<{
  $isActive?: boolean;
  $isCompleted?: boolean;
}>(({ $isActive, $isCompleted }) => ({
  flex: 1,
  textAlign: "center",
  fontSize: "13px",
  fontWeight: $isActive ? 700 : $isCompleted ? 600 : 500,
  color: $isActive
    ? colors.PURPLE
    : $isCompleted
    ? colors.BLACK
    : colors.GREY_6,
  position: "relative",
  letterSpacing: "0.3px",
  lineHeight: "1.3",
  transition: "all 0.3s ease-in-out",

  // Subtle text shadow for mobile depth (improves readability)
  textShadow: $isActive
    ? "0 0 10px rgba(139, 92, 246, 0.35)"
    : "none",

  // Active state pulse animation
  ...($isActive && {
    animation: "subtle-pulse 2s ease-in-out infinite",
  }),

  "@keyframes subtle-pulse": {
    "0%, 100%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.85,
    },
  },

  // Optional: Add checkmark for completed steps
  ...($isCompleted && !$isActive && {
    "&::before": {
      content: '"✓ "',
      color: colors.PURPLE,
      fontWeight: 700,
      marginLeft: "2px",
    },
  }),

  // Better touch targets for mobile (accessibility)
  minHeight: "22px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "2px 4px",

  // Mobile font rendering (critical for readability)
  WebkitFontSmoothing: "antialiased",
  MozOsxFontSmoothing: "grayscale",

  // Prevent text selection on mobile (UX improvement)
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
}));
